import gql from 'graphql-tag';

export default gql`
query getAdminMinioCredentials {
    getAdminMinioCredentials {
        minio_access_key
        minio_secret_key
        minio_endpoint
        minio_bucket
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/getAdminMinioCredentials.ts